import weather from "@/api/weather";

export default {
    state: {
        histories: [],
        accumulations: [],
        hourlyHistories: [],
        nowTemp: [],
    },
    mutations: {
        ["RETRIEVE_WEATHER"](state, data) {
            state.histories = data;
        },
        ["RETRIEVE_ACCUMULATIONS"](state, data) {
            state.accumulations = data;
        },
        ["RETRIEVE_WEATHER_HOURLY"](state, data) {
            state.hourlyHistories = data;
        },
        ["RETRIEVE_WEATHER_NOWTEMP"](state, data) {
            state.nowTemp = data;
        },
    },
    actions: {
        async retrieveWeatherLatest(context) {
            try {
                // console.log("retrieveWeatherLatest");
                let params = {
                    account_id: await context.dispatch("showAccountID")
                }
                let res = await weather.showLatest(params);
                return res.data.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveWeatherHistories(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                let res = await weather.showHistories(params);
                context.commit("RETRIEVE_WEATHER", res.data.data);
                return res.data.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveAccumulation(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                let res = await weather.showAccumulation(params);
                context.commit("RETRIEVE_ACCUMULATIONS", res.data.data);
                return res.data.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveTodayWeatherHourlyHistories(context) {
            try {
                let params = {};
                params.account_id = await context.dispatch("showAccountID");
                const fromDt = new Date();
                const toDt = new Date();
                toDt.setDate(fromDt.getDate() + 1);
                params.from_datetime =
                    fromDt.getFullYear() +
                    "-" +
                    ("0" + (fromDt.getMonth() + 1)).slice(-2) +
                    "-" +
                    ("0" + fromDt.getDate()).slice(-2) +
                    "T00:00:00+0900";
                params.to_datetime =
                    toDt.getFullYear() +
                    "-" +
                    ("0" + (toDt.getMonth() + 1)).slice(-2) +
                    "-" +
                    ("0" + toDt.getDate()).slice(-2) +
                    "T23:59:59+0900";
                let res = await weather.showHourlyHistories(params);
                context.commit("RETRIEVE_WEATHER_HOURLY", res.data.data);
                return res.data.data;
            } catch (error) {
                console.log(error);
            }
        },
        async updateNowTemperature(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID")
                }
                let res = await weather.showLatest(params);
                if (res.data.data) {
                    context.commit("RETRIEVE_WEATHER_NOWTEMP", res.data.data.temperature);
                    return;
                }
            } catch (error) {
                console.log(error);
            }
            context.commit("RETRIEVE_WEATHER_NOWTEMP", null);
        },
        async initializeWeatherInfos(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID")
                };
                await weather.init(params);
            } catch (error) {
                console.log(error);
            }
        }

    },
    getters: {
        getHistories(state) {
            return state.histories;
        },
        getAccumulationList(state) {
            return state.accumulations;
        },
        getHourlyHistories(state) {
            return state.hourlyHistories;
        },
        getNowTemperature(state) {
            return state.nowTemp;
        },
    }
};
